export default {
  homeTileLabel: 'View Analytics',
  selectDashboardLabel: 'Dashboard',
  loadingDashboard: 'Loading dashboard…',
  previewModeTitle: 'Preview',
  previewModeMessage: 'The real dashboard will be connected soon. This space is the same size the dashboard will be.',
  testEnvironmentBadge: 'Test environment',
  aadConnectTitle: 'Sign in with Microsoft',
  aadConnectMessage: 'This dashboard doesn\'t have service credentials configured yet. Sign in with a Microsoft account with workspace access.',
  aadConnectButton: 'Connect with Microsoft',
  aadConnectError: 'Couldn\'t sign in or load the dashboard. Check that your account has access to the workspace.',
  noDashboardsTitle: 'You don\'t have any Analytics dashboards assigned.',
  reportsLoadingTitle: 'Loading your dashboards…',
  reportsLoadErrorTitle: 'We couldn\'t load your dashboards.',
  noAccessTitle: 'You don\'t have access to this dashboard.',
  noAccessSubtitle: 'Ask your administrator for access.',
  loadErrorTitle: 'Couldn\'t load the dashboard.',
  loadErrorSubtitle: 'Try again or contact support.',
  upstreamErrorTitle: 'Couldn\'t connect to Power BI.',
  upstreamErrorSubtitle: 'Try again later.',
  refresh: 'Refresh',
  fullscreen: 'Full screen',
  print: 'Print',
  printError: 'Couldn\'t open the print dialog. Check that your browser isn\'t blocking pop-ups.',
  download: 'Download',
  formatPdf: 'PDF',
  formatPptx: 'PowerPoint',
  downloadDialogTitle: 'Download dashboard ({format})',
  downloadPreparing: 'Preparing your download…',
  downloadInProgress: 'Building the document… {percent}%',
  downloadReady: 'Ready, starting the download…',
  downloadCloseButton: 'Close',
  downloadClosedHint: 'The download is still running. We will let you know in your notifications when it is ready.',
  downloadGenerateAnotherLink: 'Changed the filters? Generate another download',
  downloadAnotherStarted: 'A new download was started. The previous one keeps running and will notify you separately.',
  downloadSuccess: 'Your dashboard was downloaded.',
  downloadFileError: 'The document was created but could not be downloaded. You will find it in your notifications.',
  downloadErrorBookmark: 'We could not read the dashboard filters. Reload the page and try again.',
  downloadErrorForbidden: 'You do not have access to this dashboard.',
  downloadErrorInvalidFormat: 'Unsupported format.',
  downloadErrorBookmarkTooLarge: 'The dashboard state could not be saved. Try again with fewer filters applied.',
  downloadErrorRateLimited: 'You reached the hourly download limit. Try again in {minutes} min.',
  downloadErrorDisabled: 'Dashboard downloads are temporarily disabled.',
  downloadErrorNotSupported: 'This dashboard cannot be downloaded.',
  downloadErrorConfig: 'Configuration error, please contact support.',
  downloadErrorUpstream: 'Could not connect to Power BI. Try again later.',
  downloadErrorNotFound: 'We could not find that download.',
  downloadErrorFailed: 'Power BI could not build the document.',
  downloadErrorTimeout: 'The download took too long. Try again later.',
  downloadErrorCapacityBusy: 'The service is busy. Try again in a few minutes.',
  downloadErrorUnexpected: 'The download could not be completed. Try again.',

  // Admin de Analytics del super admin
  hub_title: 'Analytics',
  hub_subtitle: 'Manage the Power BI dashboards and who can see them.',
  tab_organizations: 'Organizations',
  tab_dashboards: 'Dashboard catalog',
  source_banner_text: 'Changes are not live yet. The access you see and edit here is saved, but users keep seeing ' +
    'the previous configuration until this source is activated. You can prepare everything now.',

  dashboard_new_button: 'New dashboard',
  dashboards_empty: 'There are no dashboards to show.',
  dashboard_search_placeholder: 'Search dashboard',
  filter_type: 'Type',
  filter_status: 'Status',
  filter_all: 'All',
  filter_status_active: 'Active',
  filter_status_inactive: 'Inactive',

  column_position: '#',
  column_dashboard: 'Dashboard',
  column_type: 'Type',
  column_organizations: 'Organizations',
  column_users: 'Users',
  column_status: 'Status',

  dashboard_type_general: 'General',
  dashboard_type_specific: 'Specific',
  dashboard_type_general_desc: 'Part of the kit offered to any organization',
  dashboard_type_specific_desc: 'Tailored for one or a few organizations',
  dashboard_status_active: 'Active',
  dashboard_status_inactive: 'Inactive',
  action_activate: 'Activate',
  action_deactivate: 'Deactivate',
  action_change_connection: 'Change connection',

  dashboard_reorder_button: 'Reorder',
  dashboard_reorder_hint: 'This is the default order and only includes general dashboards: specific ones keep their place. ' +
    'Organizations with a custom order do not change.',
  dashboard_reorder_changed: 'Order changed',
  dashboard_reorder_save: 'Save order',

  dashboard_incomplete_chip: 'Incomplete setup',
  dashboard_incomplete_field_singular: 'The Power BI {field} is missing',
  dashboard_incomplete_field_plural: 'Missing Power BI fields: {fields}',
  dashboard_incomplete_banner_title: 'This dashboard will not load until its Power BI connection is complete',
  dashboard_incomplete_banner_detail_singular: 'The {field} is missing. The rest of the setup is ready.',
  dashboard_incomplete_banner_detail_plural: 'Missing: {fields}. The rest of the setup is ready.',
  dashboard_incomplete_banner_hint: 'It can be saved incomplete, but it will not load for anyone until it is completed.',

  dashboard_form_title_new: 'New dashboard',
  dashboard_card_identity: 'Identity',
  dashboard_card_connection: 'Power BI connection',
  dashboard_card_availability: 'Availability',
  dashboard_field_optional: '(optional)',
  dashboard_field_required: 'This field is required',
  dashboard_field_name: 'Name',
  dashboard_field_name_placeholder: 'e.g. Shrinkage dashboard',
  dashboard_field_description: 'Description',
  dashboard_field_description_placeholder: 'Shown under the name in the catalog',
  dashboard_field_paste_url: 'Paste Power BI URL',
  dashboard_field_paste_url_placeholder: 'https://app.powerbi.com/groups/.../reports/...',
  dashboard_field_paste_url_helper: 'Paste the report URL to fill in the IDs automatically. It isn\'t saved — it\'s just a ' +
    'shortcut; you can also fill in the fields below by hand.',
  dashboard_field_paste_url_applied: 'Values extracted from the URL last time',
  dashboard_field_paste_url_unrecognized: 'URL not recognized. Use the report URL from its workspace; Power BI app URLs don\'t ' +
    'include the workspace.',
  dashboard_field_workspace_id: 'Workspace ID',
  dashboard_field_report_id: 'Report ID',
  dashboard_field_dataset_id: 'Dataset ID',
  dashboard_field_rls_role: 'RLS role',
  dashboard_field_rls_role_placeholder: 'e.g. ClientRole',
  dashboard_field_guid_placeholder: 'GUID',
  dashboard_field_guid_missing_placeholder: 'Missing — paste it from Power BI',
  dashboard_field_guid_invalid: 'Must be a GUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).',
  dashboard_field_type: 'Type',

  dashboard_usage_title: 'Where it is used',
  dashboard_usage_summary: 'Enabled in {organizations} · {users}',
  dashboard_usage_organizations_count: '{count} organization | {count} organizations',
  dashboard_usage_users_count: '{count} user with access | {count} users with access',
  dashboard_usage_search_placeholder: 'Search organization',
  dashboard_usage_no_results: 'No organizations match',
  dashboard_usage_empty_new: 'After saving it, enable it for an organization from its detail page.',
  dashboard_usage_empty: 'Not enabled in any organization yet. Enable it from an organization\'s detail page.',
  dashboard_usage_empty_incomplete_singular: 'Not enabled in any organization yet. It cannot be enabled until the {field} is completed.',
  dashboard_usage_empty_incomplete_plural: 'Not enabled in any organization yet. It cannot be enabled until these are completed: {fields}.',


  dashboard_deactivate_title: 'Deactivate dashboard',
  dashboard_deactivate_message: '{name} will stop being visible in {organizations} ({users}). ' +
    'Its setup and access are kept: if you reactivate it, they come back.',
  dashboard_deactivate_users_count: '{count} user | {count} users',
  dashboard_connection_title: 'Change the Power BI connection',
  dashboard_connection_message: '{name} is used in {organizations} ({users}). ' +
    'Once saved, the report from the new connection will be shown.',

  notify_saved: 'Dashboard saved',
  notify_reordered: 'Order saved',
  notify_reorder_stale: 'The catalog changed while you were reordering. Please reorder again.',
  notify_activated: 'Dashboard activated',
  notify_deactivated: 'Dashboard deactivated',
  notify_error: 'Something went wrong. Please try again.',

  organizations_enable_button: 'Enable Analytics for an organization',
  organizations_search_placeholder: 'Search organization by name or ID',
  organizations_kpi_active: 'Active organizations',
  organizations_kpi_users: 'Users with access',
  organizations_kpi_attention: 'Need attention',
  organizations_kpi_attention_caption: 'Click to filter',
  organization_filter_all: 'All',
  organization_filter_active: 'Active',
  organization_filter_paused: 'Paused',
  organization_filter_attention: 'Need attention',
  organizations_empty_title: 'No organization has Analytics yet',
  organizations_empty_text: 'Enable Analytics for your first organization to choose its dashboards and who can see them.',
  organizations_no_results: 'No organizations match “{search}”',
  organizations_no_results_status: 'No organizations with that status',
  organizations_no_results_filter_hint: 'The status filter may be hiding results.',
  organizations_clear_search: 'Clear search',

  column_id: 'ID',
  column_organization: 'Organization',
  column_dashboards: 'Dashboards',
  column_users_with_access: 'Users with access',

  organization_status_active: 'Active',
  organization_status_paused: 'Paused',
  organization_rls_missing_chip: 'Missing',
  organization_attention_hint: 'Needs attention: no RLS identity',
  organization_id_subtitle: 'ID {id}',
  organization_active_toggle: 'Analytics active',
  organization_paused_title: 'Analytics is paused for {organization}',
  organization_paused_text: 'Changes are saved, but nobody sees them until it is reactivated.',
  organization_load_error: 'The organization could not be loaded.',
  tab_org_dashboards: 'Dashboards',
  tab_org_users: 'Users',

  enable_title: 'Enable Analytics',
  enable_field_organization: 'Organization',
  enable_field_organization_hint: 'Only active or demo organizations that do not have Analytics yet are listed.',
  enable_no_organizations: 'No organizations available',
  enable_field_rls_placeholder: 'E.g. {id}',
  enable_field_rls_hint: 'Value agreed with whoever maintains the client\'s Power BI dataset. It filters their data: ' +
    'a wrong value can show them another organization\'s data.',
  enable_rls_same_as_id: 'Same as the organization ID',
  enable_rls_change: 'Change',
  enable_rls_empty_warning: 'You can set it later, but the dashboards will not load until then.',
  enable_field_dashboards: 'Dashboards to enable',
  enable_select_all: 'Select all',
  enable_clear_all: 'Clear all',
  enable_incomplete_tooltip: 'Incomplete setup',
  enable_dashboards_empty: 'There are no dashboards in this group',
  enable_dashboards_no_match: 'No dashboards match “{search}”',
  enable_dashboards_error: 'The dashboard catalog could not be loaded.',
  action_retry: 'Try again',
  enable_submit: 'Enable',
  group_general: 'General kit',
  group_specific: 'Specific',

  rls_label: 'RLS identity',
  rls_hint: 'Filters this organization\'s data inside Power BI',
  rls_missing_title: 'No RLS identity',
  rls_missing_text: 'No dashboard will load for this organization',
  rls_capture: 'Set',
  rls_edit_title: 'Edit RLS identity',
  rls_capture_title: 'Set RLS identity',
  rls_current_value: 'Current value',
  rls_new_value: 'New value',
  rls_warning: 'A wrong value can show {organization} another organization\'s data.',
  rls_confirm: 'I confirm this value belongs to {organization} (ID {id})',

  order_catalog: 'Catalog',
  order_catalog_hint: 'Follows the catalog order and updates with it',
  order_custom: 'Custom',
  order_custom_hint: 'This organization has its own order',
  enabled_title: 'Enabled ({count})',
  enabled_drag_hint: 'Drag to reorder',
  enabled_empty_title: 'This organization has no dashboards yet',
  enabled_empty_text: 'Add them from the “Available” list on the right →',
  enabled_empty_add_kit: 'Add the whole general kit',
  available_title: 'Available',
  available_add: 'Add',
  available_add_kit: 'Add the whole kit',
  available_has_kit: 'Already has the whole kit',
  available_incomplete: 'Incomplete setup in the catalog',
  pending_remove: 'Will be removed when you save',
  pending_add: 'Will be added when you save',
  pending_undo: 'Undo',
  pending_added_count: '{count} dashboard added | {count} dashboards added',
  pending_removed_count: '{count} dashboard removed | {count} dashboards removed',
  pending_save: 'Save changes',

  pause_title: 'Pause Analytics for {organization}',
  pause_message: 'Nobody has access to its dashboards yet. Nothing is deleted: when you reactivate it, everything comes back. | ' +
    'The user with access will stop seeing its dashboards right away. Nothing is deleted: when you reactivate it, they get access back. | ' +
    'The {count} users with access will stop seeing its dashboards right away. Nothing is deleted: when you reactivate it, they get access back.',
  action_pause: 'Pause',
  remove_title: 'Remove dashboard | Remove dashboards',
  remove_message_singular: '{dashboard} will no longer be visible to {users} of {organization}. ' +
    'Their access is kept: if you enable it again, they get it back.',
  remove_message_plural: '{dashboards} will no longer be visible to {users} of {organization}. ' +
    'Their access is kept: if you enable them again, they get it back.',
  action_remove: 'Remove',
  discard_title: 'Discard changes?',
  discard_message: 'The changes to this organization\'s dashboards have not been saved.',
  discard_message_unsaved: 'The changes you made have not been saved.',
  discard_keep: 'Keep editing',
  action_discard: 'Discard',

  organization_users_subtitle: 'ID {id} · {count} user in the organization | ID {id} · {count} users in the organization',
  users_search_placeholder: 'Search by name or email',
  users_filter_access: 'Access',
  users_access_with: 'With access',
  users_access_without: 'Without access',
  users_filter_dashboard: 'Dashboard',
  users_filter_franchise: 'Business unit',
  users_dashboard_any: 'Any',
  users_search_widened: 'Showing all matching users',
  users_no_dashboards_title: 'Enable dashboards for {organization} first',
  users_no_dashboards_text: 'There are no dashboards enabled in this organization yet, ' +
    'so there is nothing to give its users.',
  users_go_to_dashboards: 'Go to Dashboards',
  users_empty_title: 'Nobody in {organization} has access yet',
  users_empty_text: 'Search for a user of {organization} above to give them access to the only enabled dashboard. | ' +
    'Search for a user of {organization} above to give them access to any of its {count} enabled dashboards.',
  users_no_results: 'No users match',
  users_clear_filters: 'Clear search and filters',

  column_user: 'User',
  column_franchise: 'Business unit',
  user_suspended: 'Suspended',
  user_suspended_tooltip: 'Suspended user: cannot receive access',
  dashboard_header_count: '{name} · {count}',
  dashboard_inactive_tooltip: 'Inactive in the catalog: nobody sees it',
  dashboard_incomplete_tooltip: 'Incomplete setup: nobody sees it',

  users_selected_count: '{count} user selected | {count} users selected',
  users_clear_selection: 'Clear selection',
  users_grant_menu: 'Give access to…',
  users_revoke_menu: 'Remove access to…',
  users_all_dashboards: 'All dashboards ({count})',
  grant_all_title: 'Give access to all dashboards ({count})',
  grant_all_message: 'You are about to give access to all the enabled dashboards of {organization} to {count} user: {people}. ' +
    'Those who already had access will not change. | ' +
    'You are about to give access to all the enabled dashboards of {organization} to {count} users: {people}. ' +
    'Those who already had access will not change.',
  grant_one_title: 'Give access to {dashboard}',
  grant_one_message: 'You are about to give access to {dashboard} to {count} user of {organization}: {people}. ' +
    'Those who already had it will not change. | ' +
    'You are about to give access to {dashboard} to {count} users of {organization}: {people}. ' +
    'Those who already had it will not change.',
  revoke_all_title: 'Remove access to all dashboards',
  revoke_all_message: '{count} user of {organization} will stop seeing their dashboards right away: {people}. | ' +
    '{count} users of {organization} will stop seeing their dashboards right away: {people}.',
  revoke_one_title: 'Remove access to {dashboard}',
  revoke_one_message: '{count} user of {organization} will stop seeing {dashboard} right away: {people}. | ' +
    '{count} users of {organization} will stop seeing {dashboard} right away: {people}.',
  grant_skipped_suspended: 'Skipping {count} suspended user, who cannot receive access. | ' +
    'Skipping {count} suspended users, who cannot receive access.',
  action_grant: 'Give access',
  action_revoke: 'Remove access',
  people_more: '{count} more',

  notify_enabled: 'Analytics enabled for {organization}',
  notify_paused: 'Analytics paused for {organization}',
  notify_reactivated: 'Analytics reactivated for {organization}',
  notify_rls_saved: 'RLS identity saved',
  notify_dashboards_saved: 'Changes saved',
  notify_dashboards_stale: 'The catalog changed while you were editing. Review the dashboards and save again.',
  notify_access_granted: 'Access given to {count} user | Access given to {count} users',
  notify_access_revoked: 'Access removed from {count} user | Access removed from {count} users',
  notify_access_granting: 'Assigning permission… | Assigning permissions…',
  notify_access_revoking: 'Removing permission… | Removing permissions…',
  notify_access_saved_grant: 'Permission assigned | Permissions assigned',
  notify_access_saved_revoke: 'Permission removed | Permissions removed',
  notify_only_suspended: 'The selected users are suspended and cannot receive access',
  notify_selection_limit: 'You can select up to {count} users at a time',
  notify_access_unchanged_grant: 'No changes: they already had that access',
  notify_access_unchanged_revoke: 'No changes: they did not have that access',
  notify_dashboard_not_enabled: 'That dashboard is not enabled for {organization} | ' +
    'Those dashboards are not enabled for {organization}',
  notify_users_not_in_organization: 'Some users are no longer part of {organization} or were suspended'
}
